export * from './lib/inmuebles.service';
export * from './lib/inmuebles-data-access.module';
